import { useContext } from 'react';
import { FormViewContext } from './formViewContext';

export function useFormView() {
    const formViewContext = useContext(FormViewContext);
    if (!formViewContext) {
        throw new Error('useFormView must be wrapped in a FormViewProvider');
    }
    return formViewContext;
}
